import { useRouter } from 'next/router'
import Cookies from 'js-cookie'

const Footer = ({}) => {
  const router = useRouter()

  const logoutUser = async () => {
    Cookies.remove('authed')
    router.push('/login')
  }

  return (
    <footer className="pb-12 pt-6 mt-8 border-t border-gray-200 max-w-7xl mx-auto">
      <div className="  sm:px-6 md:flex md:items-center md:justify-between lg:px-0">
        <div className="flex justify-center space-x-6 md:order-2">
          <a
            target="_blank"
            href="https://onepager.io/"
            className="flex items-center hover:opacity-50 cursor-pointer opacity-30"
          >
            <img
              className="h-6 lg:h-8 w-auto filter grayscale"
              src="https://cdn.filestackcontent.com/jW9hY5L5RAWWpn2rGhw9"
              alt="onepager"
            />
            <h2 className="ml-2 text-lg lg:text-xl font-bold appTitleItem -mt-1">
              onepager
            </h2>
          </a>
        </div>
        <div className="mt-8 md:mt-0 md:order-1">
          <div className="flex space-x-4 text-xs text-gray-400 mb-1">
            <a target="_blank" href="https://onepager.io/privacy-policy">
              Privacy Policy
            </a>
            <a target="_blank" href="https://onepager.io/terms-conditions">
              Terms of Service
            </a>

            <a href="#" onClick={logoutUser}>
              Logout
            </a>
          </div>
          <p className="text-xs text-gray-400">&copy; onepager.io</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
